/* eslint-disable @typescript-eslint/no-explicit-any */
import { Modal } from 'ant-design-vue';
import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

class ApiHelper {
  baseUrl: string;
  service: AxiosInstance;

  constructor() {
    let baseURL = 'https://gdapi.hzjtzxpro.com';
    if (process.env.NODE_ENV === 'development') {
      baseURL = 'http://localhost:5050';
    }
    this.baseUrl = baseURL;
    this.service = axios.create(
      {
        baseURL: this.baseUrl,
        timeout: 10000,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    this.service.interceptors.request.use(
      (config:InternalAxiosRequestConfig) => {
        // 读取身份令牌
        const token = localStorage.getItem('OnlineBusinessHall.Token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error:any) => {
        Modal.error({
          title: '请求操作发生错误',
          content: error.message,
        });
        return Promise.reject(error);
      }
    );

    this.service.interceptors.response.use(
      (response: AxiosResponse) => {
        if (response.status === 200) {
          // 如果是Blob类型的响应，直接返回，不做处理
          if (response.config.responseType === 'blob') {
            return response;
          }
          
          try {
            const body = response.data;

            if (body.code === '200') {
              return Promise.resolve(body);
            } else {
              Modal.warning({
                title: '温馨提示！',
                content: `${body.msg}`,
              });
              return Promise.reject(body.msg);
            }
          } catch(error: any) {
            Modal.warning({
              title: '解析响应数据异常!',
              content: `${error.message}`,
            });
            return Promise.reject(response);
          }
        } else {
          Modal.warning({
            title: '请求响应发生异常!',
            content: `${response.statusText}`,
          });
          return Promise.reject(response);
        }
      },
      (error: any) => {
        Modal.error({
          title: '请求操作发生错误',
          content: error.message,
        });
        return Promise.reject(error);
      }
    );

    return this;
  }

  async get<T>(url: string, p0?: { responseType: string; headers: { Accept: string; }; }): Promise<T> {
    const response = await this.service.get<T>(this.baseUrl + url);
    return response.data;
  }

  async post<T>(url: string, data: any): Promise<T> {
    const response = await this.service.post<T>(this.baseUrl + url, data);
    return response.data;
  }

  async put<T>(url: string, data: any): Promise<T> {
    const response = await this.service.put<T>(this.baseUrl + url, data);
    return response.data;
  }

  async delete<T>(url: string): Promise<T> {
    const response = await this.service.delete<T>(this.baseUrl + url);
    return response.data;
  }
  
  async getBlob(url: string): Promise<Blob> {
    const response = await this.service.get(this.baseUrl + url, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
    return response.data;
  }
}

export const apiHelper = new ApiHelper();